
const API_URL = ""; 

export const getAuthToken = () => sessionStorage.getItem("visionguard_token");
export const setAuthToken = (token) => sessionStorage.setItem("visionguard_token", token);
export const clearAuthToken = () => sessionStorage.removeItem("visionguard_token");
export const getRole = () => sessionStorage.getItem("visionguard_role");
export const setRole = (role) => sessionStorage.setItem("visionguard_role", role);

export const apiFetch = async (url, options = {}) => {
  const token = getAuthToken();
  const headers = {
    ...options.headers,
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
  
  const response = await fetch(`${API_URL}${url}`, { ...options, headers });
  if (response.status === 401 && !url.includes("/login")) {
      clearAuthToken();
      window.location.reload(); // Force re-login
  }
  return response;
};
